<template>
    <Form>
        <h2>Reset password</h2>
        <v-form v-model="valid" @submit.prevent="submit" ref="form">
            <v-alert v-if="error" color="red" icon="mdi-alert-octagon-outline" outlined text>
                {{ error }}
            </v-alert>
            <v-alert v-if="message" color="green" outlined text>
                {{ message }}
            </v-alert>
            <div class="font-weight-medium">Email</div>
            <v-text-field outlined dense type="email" v-model="form.Email" :rules="[$validators.isEmail]" />

            <v-btn block type="submit" :disabled="!valid || !!message" :loading="loading" class="blue-btn">Send a reset link</v-btn>
        </v-form>
        <div v-if="!external" class="pa-12">
            <p class="text-center">
                <router-link :to="{ name: 'signin', query: $route.query }" class="text-no-wrap">Back to Log In</router-link>
            </p>
        </div>
    </Form>
</template>

<script>
import Form from '@/pages/Form';

export default {
    components: { Form },
    props: {
        email: String,
    },

    data() {
        return {
            form: {
                Email: this.$route.query.email || this.email,
                ReturnURL: this.$route.query.next,
            },
            valid: false,
            error: '',
            message: '',
            loading: false,
            external: !!this.$route.query.next,
        };
    },

    methods: {
        submit() {
            this.loading = true;
            this.message = '';
            this.error = '';
            this.$api.sendResetPasswordEmail(this.form, (data, meta) => {
                this.loading = false;
                if (meta.code < 400) {
                    this.message = 'If an account is associated with this email, you will receive a reset link. Please check your email.';
                    return;
                }
                if (meta.code === 404) {
                    this.message = 'We did not find email/password account with this email. Try to login with Google.';
                    return;
                }
                this.error = 'Failed to send a reset link, please try again later.';
            });
        },
    },
};
</script>

<style scoped></style>
